module.exports = window["core-js/modules/es.function.name.js"];